import { SearchEventsRefinementsLoadable } from '#/modules/search/events/components/Refinements/SearchEventsRefinementsLoadable';
import { SearchInternshipRefinementsLoadable } from '#/modules/search/internships/components/Refinements/SearchInternshipRefinementsLoadable';
import { SearchJobsRefinementsLoadable } from '#/modules/search/jobs/components/Refinements/SearchJobsRefinementsLoadable';
import { SearchOrgRefinementsLoadable } from '#/modules/search/orgs/components/Refinements/SearchOrgRefinementsLoadable';
import { SearchVolopsRefinementsLoadable } from '#/modules/search/volops/components/Refinements/SearchVolopsRefinementsLoadable';
import type { ListingType } from '#/types/ListingType';

type Args = {
  searchType: ListingType;
};

export function SearchRefinementsSwitch({ searchType }: Args) {
  switch (searchType) {
    case 'JOB':
      return <SearchJobsRefinementsLoadable />;
    case 'INTERNSHIP':
      return <SearchInternshipRefinementsLoadable />;
    case 'VOLOP':
      return <SearchVolopsRefinementsLoadable includeSourcesFacet={false} />;
    case 'ORG':
      return <SearchOrgRefinementsLoadable />;
    case 'EVENT':
      return <SearchEventsRefinementsLoadable />;
  }
}
